import { render, staticRenderFns } from "./IntegerInput.vue?vue&type=template&id=60b1d5a6&scoped=true&"
import script from "./IntegerInput.vue?vue&type=script&lang=js&"
export * from "./IntegerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b1d5a6",
  null
  
)

export default component.exports